import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import FormTextField from '../form/redux-form/FormTextField';
import FormCheckBox from '../form/redux-form/FormCheckBox';
import FormImageUpload from '../form/redux-form/FormImageUpload';
import { Link } from 'react-router-dom';
import routePaths from '../../routePaths';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { validateSync, validateAsync } from '../../models/bikeTypes/bikeTypeModelValidation';
import FormSelect from '../form/redux-form/FormSelect';

let BikeTypeEditForm = ({
  initialValues,
  handleSubmit,
  isEdit,
  valid,
  submitting,
  pristine,
  globalBikeTypes }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h5" gutterBottom>{isEdit ? 'Edycja typu rowerów' : 'Nowy typ rowerów'}</Typography>
      <Paper className="config-section" elevation={3}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Field
            name="name"
            component={FormTextField}
            label="Nazwa typu"
          />
          {globalBikeTypes.length > 0 ? <Field
            name="globalBikeTypeId"
            component={FormSelect}
            style={{ width: 200 }}
            values={{ default: { value: null, name: '' }, ...globalBikeTypes.map(bt => ({ value: bt.id, name: bt.name.pl })) }}
            label="Globalny typ roweru"
          /> : null}
          <Field
            name="internalUseOnly"
            component={FormCheckBox}
            label="Rower testowy"
          />
          <Typography variant="body2" style={{ marginTop: 16 }}>Wymagane ikony w formacie png, z przeźroczystym tłem o rozmiarze 80x92</Typography>
          <Field
            type="file"
            name="availableBikeIconDataUri"
            component={FormImageUpload}
            label="Ikona dostępnego roweru"
            fallbackImageUri={initialValues.availableBikeIconUri}
          />
          <Field
            type="file"
            name="occupiedBikeIconDataUri"
            component={FormImageUpload}
            label="Ikona zajętego roweru"
            fallbackImageUri={initialValues.occupiedBikeIconUri}
          />
        </div>
      </Paper>
      <br />
      <div className="actions">
        <Button style={{ marginRight: 8 }} component={Link} to={routePaths.bikeTypes} disabled={submitting}>
          Anuluj
        </Button>
        <Button variant="contained" color="primary" type="submit" disabled={!valid || submitting || pristine}>
          {submitting ? 'Zapisywanie...' : 'Zapisz'}
        </Button>
      </div>
    </form>
  );
};

BikeTypeEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  valid: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  globalBikeTypes: PropTypes.array.isRequired,
};

BikeTypeEditForm = reduxForm({
  form: 'bikeTypeEditForm',
  validate: validateSync,
  asyncValidate: validateAsync,
  enableReinitialize: true
})(BikeTypeEditForm);

BikeTypeEditForm = connect(
  state => ({
    initialValues: state.bikeTypes.current,
  })
)(BikeTypeEditForm);

export default BikeTypeEditForm;
